import styled from 'styled-components';

export default styled.p`
  a, span {
    color: inherit;
    font-weight: 600;
    text-decoration: underline;
    display: inline;
    border: none;
    background: none;
    padding: 0;
    margin: 0;
  }
`;
